import { useI18n } from "../i18n/I18nProvider";

export const LOW_STOCK_THRESHOLD = 3;

export function StockBadge({ stock }: { stock: number }) {
  const { t } = useI18n();
  if (stock <= 0) return <span className="stock stock-out">{t("product.outOfStock")}</span>;
  if (stock <= LOW_STOCK_THRESHOLD) return <span className="stock stock-low">{t("product.lowStock", { count: stock })}</span>;
  return <span className="stock stock-in">{t("product.inStock")}</span>;
}
